import { BoardPieceActorType } from "../machines/gameMachine/types";
import { CoordsType } from "../types";

export const getBoardPieceCoords = (boardPiece: BoardPieceActorType): CoordsType => boardPiece.state.context.coords;
